export default __webpack_public_path__ + "static/media/Sealant-more.465c0f05.png";